<template>
  <div class="wrapper landing">
    <main class="content">
      <app-header :back="back"></app-header>
      <header class="page landing">
        <h1 class="title">My SeedMix</h1>
        <p class="subtitle">by Millborn Seeds</p>
      </header>
      <button class="btn btn-primary" @click.prevent="handleNewMix">Start a New Mix</button>
      <button class="btn btn-secondary" @click="showModal = true">Resume A Mix</button>
    </main>
    <modal :shown="showModal" @close="hideModal" name="Resume a Mix">
      <form class="form">
        <p>Enter the code you received when you saved your mix.</p>
        <div class="form-row">
          <label for="resume-mix-url" class="form-label">Mix Code</label>
          <div class="input-group" :class="{'has-error': $v.mixCode.$error || mixError}">
            <input id="resume-mix-url" type="text" class="form-control" v-model.trim="$v.mixCode.$model" autofocus>
            <div class="error" v-if="!$v.mixCode.required">Please enter your mix code</div>
            <div class="error" v-if="mixError">{{mixError}}</div>
          </div>
        </div>
        <div class="form-row">
          <button class="btn btn-primary has-arrow" @click.prevent="handleSubmit">Resume this mix</button>
        </div>
        <p v-if="submitMessage === 'PENDING'">Fetching...</p>
      </form>
    </modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Modal from '@/components/Modal'
import Header from '@/components/Header'
import axios from 'axios'
import { page } from 'vue-analytics'
export default {
  name: 'home',
  components: {
    'modal': Modal,
    'app-header': Header
  },
  data () {
    return {
      showModal: false,
      mixCode: '',
      submitMessage: '',
      mixError: false,
      back: false
    }
  },
  validations: {
    mixCode: { required }
  },
  methods: {
    track () {
      page('/')
    },
    hideModal () {
      this.showModal = false
    },
    handleNewMix () {
      this.$store.commit('reset')
      this.$router.push({
        name: 'loading'
      })
    },
    handleSubmit () {
      this.submitMessage = 'PENDING'
      this.mixError = false
      axios.get(this.$store.state.storeDomain + '/wp-json/millborn/v1/get/' + this.mixCode)
        .then(response => {
          if (response.data.result === 'success') {
            // make sure we have the pieces we expect
            let savedState = response.data.data
            if ('path' in savedState && 'formData' in savedState) {
              this.$store.state.formData = savedState.formData
              this.$emit('updateTotals')
              this.$router.push({
                path: savedState.path
              })
            } else {
              this.mixError = 'Sorry, this mix couldn\'t be resumed'
              // console.log('Mix found, but did not include path and formData.')
            }
          } else {
            this.mixError = 'Sorry, we couldn\'t find that mix'
          }
          this.submitMessage = ''
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss">
  // @import "../styles/app.scss";
</style>
